import { useContext } from 'preact/hooks'
import { CompanyContext, CompanyState } from './companyContext'

export const useCompany = (): CompanyState => {
  const ctx = useContext(CompanyContext)
  if (!ctx) throw new Error('useCompany must be used within a CompanyProvider')
  return ctx
}
